module.exports = __webpack_public_path__ + "static/media/forgot-password-office.ac5c499b.jpeg";